/*
 * Usage: new RDDragAndDropList(myDropCallback);
 * Here, myDropCallback is called with keywords dragElement and
 * droppedOnElement with the element being dragged and the element
 * it was dropped on, respectively.
 */
export default class RDDragAndDropList {
  constructor(dropCallback) {
    this.dropCallback = dropCallback;
    this.listItems = document.querySelectorAll(
      "[draggable][data-sortable-list-item='true']"
    );

    Array.from(this.listItems).forEach((item) => {
      item.addEventListener('dragstart', (event) => {
        this.handleDragStart(event);
      });
      // prevent default for dragover to allow dropping
      item.addEventListener('dragover', (event) => {
        event.preventDefault();
      });
      item.addEventListener('drop', (event) => {
        this.handleDrop(event);
      });
    });
  }

  handleDragStart(event) {
    this.dragElement = event.currentTarget;
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/html', event.currentTarget.innerHTML);
  }

  handleDrop(event) {
    event.stopPropagation();
    this.dropCallback({
      dragElement: this.dragElement,
      droppedOnElement: event.currentTarget
    });
  }
}
